import PropTypes from 'prop-types';

import PropTypesPresenter from '../utils/PropTypesPresenter';

const APP_UPDATE_POP_UP = 'app_update_pop_up';
const WELCOME_TO_MEMBERSHIP_BANNER = 'welcome_to_membership_banner';
const CHECK_IN_POP_UP_DEFAULT = 'check_in_pop_up_default';
const CHECK_IN_POP_UP_WITH_OFFER = 'check_in_pop_up_with_offer';
const HAPPY_BIRTHDAY_PERK_BANNER = 'happy_birthday_perk_banner';
const START_EARNING_FASTCASH_BANNER = 'start_earning_fast_cash_banner';
const WELCOME_MEMBERSHIP_USER_BANNER = 'welcome_membership_user_banner';

export const BANNER_TYPES = {
  [APP_UPDATE_POP_UP]: APP_UPDATE_POP_UP,
  [WELCOME_TO_MEMBERSHIP_BANNER]: WELCOME_TO_MEMBERSHIP_BANNER,
  [CHECK_IN_POP_UP_DEFAULT]: CHECK_IN_POP_UP_DEFAULT,
  [CHECK_IN_POP_UP_WITH_OFFER]: CHECK_IN_POP_UP_WITH_OFFER,
  [HAPPY_BIRTHDAY_PERK_BANNER]: HAPPY_BIRTHDAY_PERK_BANNER,
  [START_EARNING_FASTCASH_BANNER]: START_EARNING_FASTCASH_BANNER,
  [WELCOME_MEMBERSHIP_USER_BANNER]: WELCOME_MEMBERSHIP_USER_BANNER,
};

export default new PropTypesPresenter(
  {
    id: PropTypes.string,
    bannerType: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
    fontColor: PropTypes.string,
    backgroundColor: PropTypes.string,
    icon: PropTypes.string,
    imageUrl: PropTypes.string,
    submitButtonColor: PropTypes.string,
    submitButtonText: PropTypes.string,
  },
  {
    bannerTypeReadable(bannerSetting) {
      const bannerTypeMap = {
        [APP_UPDATE_POP_UP]: 'App update pop up',
        [WELCOME_TO_MEMBERSHIP_BANNER]: 'Welcome to membership banner',
        [CHECK_IN_POP_UP_DEFAULT]: 'Check in pop up default',
        [CHECK_IN_POP_UP_WITH_OFFER]: 'Check in pop up with offer',
        [HAPPY_BIRTHDAY_PERK_BANNER]: 'Happy birthday perk banner',
        [START_EARNING_FASTCASH_BANNER]: 'Start earning fastcash banner',
        [WELCOME_MEMBERSHIP_USER_BANNER]: 'Welcome membership user banner',
      };

      const bannerType = this.bannerType(bannerSetting);

      return bannerTypeMap[bannerType];
    },
  }
);
